import React, { useState, useEffect , useRef } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import LocationPicker from "../LocationPicker"

const center = {
  lat: 40.0853,
  lng: 22.3584,
};

const Container = styled.div`
  margin: 50px;
  padding: 2rem;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  border-radius: 8px;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 25px;
  }
`;

const Title = styled.h2`
  color: #385963;
`;

const BackButton = styled.button`
  background: none;
  border: 1px solid #385963;
  color: #385963;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background-color: #f0f0f0;
  }

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const FieldWrapper = styled.div``;

const FieldTitle = styled.h4`
  margin-bottom: 1rem;
  color: #385963;
`;

const LangRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LocationRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FieldGroup = styled.div`
  margin-bottom: 1.5rem;

  label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #385963;
  }

  input, textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
  }

  textarea {
    resize: vertical;
    min-height: 100px;
  }
`;

const Button = styled.button`
  background-color: #385963;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 2rem;
  place-self: center;

  &:hover {
    background-color: #2c4a52;
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  background-color: white;
  color: #385963;

  &:focus {
    border-color: #385963;
    outline: none;
    box-shadow: 0 0 0 2px rgba(56, 89, 99, 0.2);
  }

  option {
    color: #385963;
  }
`;


const SinglePhotoContainer = styled.div`
  display: flex;
  flex-direction:column;
  align-items: center;
  margin-top: 10px;

  img{
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;


const DeleteButton = styled.button`
  background-color: #ff4d4d;  /* Red background */
  color: white;
  border: none;
  padding: 0.5rem 1rem;  /* Smaller padding */
  font-size: 0.9rem;      /* Smaller font size */
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
  
  &:hover {
    background-color: #e60000;  /* Darker red on hover */
  }
`;


const PhotoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom:20px;

  img{
    border-radius: 5px;
  }

    @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
  
`;

// FilePlaceTypeEnum
const FILE_PLACE_TYPE = {
  Gallery: 0,
  CategoryPhoto: 1,
  CoverPhoto: 2,
  Poster: 3,
};

const AddExperience = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem("token");
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const coverInputRef = useRef(null);
const categoryInputRef = useRef(null);
const galleryInputRef = useRef(null);

  
  const [form, setForm] = useState({
  name: { gr: '', en: '' },
  description: { gr: '', en: '' },
  location: { latitude: '', longitude: '' },
  categoryId: '',
  videoLink:'',
  coverPhoto: null,
  categoryPhoto: null,
  photos: [],  
  gpxFile: null
});


  const { isLoaded } = useLoadScript({
      googleMapsApiKey: "AIzaSyCIrKrxTVDqlcRVFNyNMm5iS869G7RYvuc",
      libraries: ["places"],
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}ExperienceCategory`);
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error('Error fetching Categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleChange = (field, value, lang = null) => {
    if (lang) {
      setForm((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [lang]: value,
        },
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };


  const handleFileChange = (e, isMultiple, field) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  if (isMultiple) {
    setForm(prev => ({
      ...prev,
      photos: [...prev.photos, ...Array.from(files)],
    }));
  } else if (field) {
    setForm(prev => ({
      ...prev,
      [field]: files[0],
    }));
  }
};


const uploadFiles = async (id, files, types) => {
  const formData = new FormData();

  for (let i = 0; i < files.length; i++) {
    formData.append('uploadFiles', files[i]);
    formData.append('uploadFileTypes', types[i].toString());
  }

  try {
    const response = await fetch(`${BASE_URL}Experience/${id}/uploadFiles`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${tokenString}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
       alert(t('uploadFilesFailedPleaseEditAndTryAgain'));
      throw new Error(errorText);
      
    }
  } catch (error) {
    console.error('Upload error:', error);
  }
};


  const handleCategoryChange = (value) => {
    setForm((prev) => ({
      ...prev,
      categoryId: value,
    }));
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  // Prepare payload as per API schema
  const payload = {
    name: form.name,
    description: form.description,
    categoryId: form.categoryId,
    videoLink: form.videoLink,
    location: {
      latitude: parseFloat(form.location.latitude),
      longitude: parseFloat(form.location.longitude),
    },
  };

  try {
    const response = await fetch(`${BASE_URL}Experience`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenString}`, 
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create experience');
    }

    const createdData = await response.json();
    const newId = createdData.id; //API returns the new id

    // Prepare files and types for upload
    const uploadFileList = [];
    const fileTypes = [];

    if (form.coverPhoto) {
      uploadFileList.push(form.coverPhoto);
      fileTypes.push(FILE_PLACE_TYPE.CoverPhoto);
    }
    if (form.categoryPhoto) {
      uploadFileList.push(form.categoryPhoto);
      fileTypes.push(FILE_PLACE_TYPE.CategoryPhoto);
    }
    if (form.photos.length > 0) {
      uploadFileList.push(...form.photos);
      fileTypes.push(...Array(form.photos.length).fill(FILE_PLACE_TYPE.Gallery));
    }

    if (uploadFileList.length > 0) {
      await uploadFiles(newId, uploadFileList, fileTypes);
    }

  if (form.gpxFile) {
  const gpxForm = new FormData();
  gpxForm.append('file', form.gpxFile);

  try {
    const gpxResponse = await fetch(`${BASE_URL}Experience/${newId}/uploadGpx`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${tokenString}`,
      },
      body: gpxForm,
    });

    if (!gpxResponse.ok) {
      const errorText = await gpxResponse.text();
      alert(t('uploadGpxFailed'));
      throw new Error(errorText);
    }
  } catch (gpxError) {
    console.error('Error uploading GPX file:', gpxError);
  }
}

    alert(t('experienceAddedSuccessfully'));
    navigate('/admin/experiences');
  } catch (error) {
    console.error('Error creating experience:', error);
    alert(t('errorCreatingExperience') + ': ' + error.message);
  }
};


  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');

  const handleOpenModal = (img) => {
    if (!img) return;
    setModalImage(typeof img === 'string' ? img : URL.createObjectURL(img));
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalImage('');
  };


  const handleDeleteCoverPhoto = () => {
  setForm(prev => ({
    ...prev,
    coverPhoto: null,
    coverBase64Src: '', // if applicable
  }));
   if (coverInputRef.current) {
    coverInputRef.current.value = '';
  }
};
 

const handleDeleteCategoryPhoto = () => {
 setForm(prev => ({
    ...prev,
    categoryPhoto: null,
    categoryBase64Src: '', // if applicable
  }));
   if (categoryInputRef.current) {
    categoryInputRef.current.value = '';
  }
};


const handleDeleteNewGalleryPhoto = (index) => {
  setForm(prev => ({
    ...prev,
    photos: prev.photos.filter((_, i) => i !== index),
  }));
    // Optional: reset input when all are removed
  if (form.photos.length === 1 && galleryInputRef.current) {
    galleryInputRef.current.value = '';
  }
};


  return (
    <Container>
      <TopBar>
        <BackButton onClick={() => navigate('/admin/experiences')}>
          ← {t('backToExperiences')}
        </BackButton>
        <Title>{t('addExperience')}</Title>
      </TopBar>


      <form onSubmit={handleSubmit}>
        <FormWrapper>

          {['name', 'description'].map((field) => (
            <FieldWrapper key={field}>
              <FieldTitle>{t(field)}</FieldTitle>
              <LangRow>
                <FieldGroup>
                  <label>{t(field)} (Ελληνικά)</label>
                  {field === 'description' ? (
                    <textarea
                      value={form[field].gr}
                      onChange={(e) => handleChange(field, e.target.value, 'gr')}
                      required
                    />
                  ) : (
                    <input
                      type="text"
                      value={form[field].gr}
                      onChange={(e) => handleChange(field, e.target.value, 'gr')}
                      required
                    />
                  )}
                </FieldGroup>

                <FieldGroup>
                  <label>{t(field)} (English)</label>
                  {field === 'description' ? (
                    <textarea
                      value={form[field].en}
                      onChange={(e) => handleChange(field, e.target.value, 'en')}
                      required
                    />
                  ) : (
                    <input
                      type="text"
                      value={form[field].en}
                      onChange={(e) => handleChange(field, e.target.value, 'en')}
                      required
                    />
                  )}
                </FieldGroup>
              </LangRow>
            </FieldWrapper>
          ))}

          <FieldWrapper>
            <FieldTitle>{t('category')}</FieldTitle>
            <FieldGroup>
              <StyledSelect
                value={form.categoryId}
                onChange={(e) => handleCategoryChange(e.target.value)}
                required
              >
                <option value="" disabled>
                  {t('selectCategory')}
                </option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name?.[i18n.language] || cat.name?.en}
                  </option>
                ))}
              </StyledSelect>
            </FieldGroup>
          </FieldWrapper>

       <FieldWrapper>
            <FieldTitle>{t("location")}</FieldTitle>
            <LocationPicker
              location={form.location}
              onChange={(loc) => handleChange("location", loc)}
              isLoaded={isLoaded}
            />
         </FieldWrapper>

          <FieldGroup>
            <FieldTitle>{t('videoLink')}</FieldTitle>
            <input
              type="text"
              value={form.videoLink}
              onChange={(e) => handleChange('videoLink', e.target.value)}
            />
          </FieldGroup>

          <FieldGroup>
           <FieldTitle>{t('experiencePath')} (.gpx)</FieldTitle>
           <input
             type="file"
             accept=".gpx"
             onChange={(e) => handleChange('gpxFile', e.target.files[0])}
           />
          </FieldGroup>
          {form.gpxFile && <p>{form.gpxFile.name}</p>}



          <FieldWrapper>
            <FieldTitle>{t('coverPhoto')}</FieldTitle>
            <FieldGroup>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, false, 'coverPhoto')} 
                 ref={coverInputRef}
                required
              />
            </FieldGroup>
            {(form.coverPhoto ||  form.coverBase64Src) && (
              <SinglePhotoContainer>
                <img
                 src={
                    form.coverPhoto
                      ? URL.createObjectURL(form.coverPhoto)
                      : form.coverBase64Src
                  }
                  alt="Cover"
                  style={{ width: 120, height: 120, objectFit: 'cover', cursor: 'pointer' }}
                  onClick={() =>
                    handleOpenModal(
                      form.coverPhoto
                        ? URL.createObjectURL(form.coverPhoto)
                        : form.coverBase64Src
                    )
                  }
                />
                 <DeleteButton type="button" onClick={handleDeleteCoverPhoto}>
                  {t('delete')}
                </DeleteButton>
              </SinglePhotoContainer>
            )}
          </FieldWrapper>

            <FieldWrapper>
            <FieldTitle>{t('categoryPhoto')}</FieldTitle>
            <FieldGroup>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, false, 'categoryPhoto')} 
                ref={categoryInputRef}
                required
              />
            </FieldGroup>
            {(form.categoryPhoto || form.existingCategoryFileName) && (
              <SinglePhotoContainer>
                <img
                  src={
                    form.categoryPhoto
                      ? URL.createObjectURL(form.categoryPhoto)
                      : form.categoryBase64Src
                  }
                  alt="Category"
                  style={{ width: 120, height: 120, objectFit: 'cover', cursor: 'pointer' }}
                  onClick={() =>
                    handleOpenModal(
                      form.categoryPhoto
                        ? URL.createObjectURL(form.categoryPhoto)
                        : form.categoryBase64Src
                    )
                  }
                />
                <DeleteButton type="button" onClick={handleDeleteCategoryPhoto}>
                  {t('delete')}
                </DeleteButton>
              </SinglePhotoContainer>
            )}
          </FieldWrapper>


          <FieldWrapper>
            <FieldTitle>{t('galleryPhotos')}</FieldTitle>
            <FieldGroup>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => handleFileChange(e, true)}
                ref={galleryInputRef}
              />
            </FieldGroup>
             {form.photos.map((photo, index) => (
               <PhotoItem key={`new-${index}`}>
                 <img
                   src={URL.createObjectURL(photo)}
                   alt={`Gallery new ${index}`}
                   style={{ width: 100, height: 100, objectFit: 'cover', cursor: 'pointer' }}
                   onClick={() => handleOpenModal(URL.createObjectURL(photo))}
                 />
                 <DeleteButton type="button" onClick={() => handleDeleteNewGalleryPhoto(index)}>
                   {t('delete')}
                 </DeleteButton>
               </PhotoItem>
             ))}
          </FieldWrapper>

          <Button type="submit">{t('save')}</Button>
        </FormWrapper>
      </form>
    </Container>
  );
};

export default AddExperience;




